import { AdminBugsPage as PlatformAdminBugsPage } from '@jarvis/platform-ui';
import { useAuthStore } from '../../../auth/useAuthStore';
import { useHasRole } from '../../../auth/useHasRole';
import { siteFeedbackApi } from '../../../siteSupport/config';

export function AdminBugsPage() {
  const { canAccessSiteAdmin } = useHasRole();
  const username = useAuthStore((s) => s.username) ?? 'admin';
  const displayName = useAuthStore((s) => s.displayName) ?? undefined;

  return (
    <PlatformAdminBugsPage
      api={siteFeedbackApi}
      canManage={canAccessSiteAdmin()}
      currentUserId={username}
      currentUserName={displayName}
    />
  );
}
